import {View} from 'react-native'

import {type NativeViewProps} from './types'

/**
 * Android fallback: passthrough wrapper with no context menu interaction.
 */
export default function NativeView({children, style}: NativeViewProps) {
  return <View style={style}>{children}</View>
}
